// extracted by mini-css-extract-plugin
export default {"addFavoritesButton":"favoriteHeart_addFavoritesButton__JEHaH","heartImg":"favoriteHeart_heartImg__pxR7l"};